// Cómo se nombra una compra en la URL y en el API — sin Vue ni red
// (pos-graciela-api/docs/SPEC_COMPRAS_POR_ID_v0.1.md, fase B).
//
// La compra se identifica por `id_compra`. El número del comprobante puede
// repetirse entre proveedores, así que las rutas por número quedan sólo para
// enlaces viejos: el API las resuelve y, si el número es de varias compras,
// responde 409 `compra_ambigua` con las opciones.

/** Ruta base del API para una compra: por id si se tiene; si no, por número. */
export function rutaApiCompra({ idCompra = null, nro = null } = {}) {
  if (idCompra !== null && idCompra !== undefined && String(idCompra) !== '') {
    return `/api/purchases/invoices/id/${encodeURIComponent(idCompra)}`;
  }
  return `/api/purchases/invoices/${encodeURIComponent(nro ?? '')}`;
}

/** ¿El API respondió que el número corresponde a más de una compra? */
export function esCompraAmbigua(error) {
  return error?.response?.status === 409 && error?.response?.data?.code === 'compra_ambigua';
}

/** Opciones para elegir entre las compras de un número ambiguo. */
export function opcionesCompraAmbigua(error) {
  return (error?.response?.data?.compras || []).map((c) => ({
    idCompra: c.id_compra,
    etiqueta: `${c.proveedor || 'Sin proveedor'} — ${String(c.fecha_emision || '').slice(0, 10) || 'sin fecha'}`
  }));
}
